import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Box, Button, Chip, Dialog, DialogContent, DialogTitle, Grid, IconButton, List, ListItem, ListItemText, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material';

import PrintIcon from '@mui/icons-material/Print';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import CloseIcon from '@mui/icons-material/Close';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import moment from 'moment';

import { GrNext } from "react-icons/gr";
import { GrPrevious } from "react-icons/gr";

import { RootState } from '../../../store';
import { openSnackbar } from "../../../store/slices/SnackbarSlice";
import { setReducerRecepcion } from '../../../store/slices/RecepcionSlice';

import { DialogEnviarWhatsApp } from '../../../dialogs/DialogEnviarWhatsApp';

import { TablePaddingStyle, TableTheadStyle } from '../../../styles/TableStyle';

import { ActualizarEstatus, GenerarAcuse } from '../../../connections/comun/RecepcionConnection';

import { AnexoProps } from '../../../interfaces/comun/AnexoInterface';
import { ParteProps } from '../../../interfaces/comun/ParteInterface';

interface Props {
    numeroSeguimiento:      number;    
    error:                  string;   
    handleNext:             () => void;
    handleBack:             () => void;
    Finalizar:              () => void;
    setError:               React.Dispatch<React.SetStateAction<string>>;    
    setMensajeAsignacion:   React.Dispatch<React.SetStateAction<string>>;
    setAjaxFinish:          React.Dispatch<React.SetStateAction<boolean>>;
}

export const GenerarAcusePage = ({ numeroSeguimiento, error, handleNext, handleBack, setAjaxFinish, setMensajeAsignacion, setError, Finalizar } : Props ) => {
    
    const dispatch = useDispatch();

    const recepcion = useSelector( ( state: RootState ) => state.recepcion );

    const [loading, setLoading] = useState( false );
    const [loadingBack, setLoadingBack] = useState( false );    
    const [loadingNext, setLoadingNext] = useState( false );

    const [openAcuse, setOpenAcuse] = useState( false );
    const [openEnviarWhatsApp, setOpenEnviarWhatsApp] = useState( false );

    const [documento, setDocumento] = useState( '' );

    const [anexos, setAnexos] = useState<AnexoProps[]>( [] );
    const [partes, setPartes] = useState<ParteProps[]>( [] );

    const [fullScreen, setFullScreen] = useState( false );

    const handleRegresar = async () => {

        setLoadingBack( true );

        await ActualizarEstatus({ id: recepcion.id ?? '', idEstatus: 6 }).then( resp => {
                
            const { success, message, usuarioActualAsignacion, usuarioAsignacion } = resp;

            if( success ){

                setTimeout(() => {
                       
                    if( usuarioActualAsignacion ){
                        handleBack();
                        setLoadingBack( false );
                    }
                    else{                        
                        setAjaxFinish( true );
                        setMensajeAsignacion( 'La siguiente actividad se asignó a ' + ( usuarioAsignacion ?? '' ) );  
                    }
                    
                }, 700);
            }
            else {

                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: message, variant: 'error' }));   
                    setLoadingBack( false );

                }, 700);

            }

        }); 

    }

    const handleSiguiente = async () => {

        if( recepcion?.provieneBuzonElectronico )
        {
            setLoadingNext( true );       
            setError( '' );        
            Finalizar();
        }
        else {

            setLoadingNext( true );

            await ActualizarEstatus({ id: recepcion.id ?? '', idEstatus: 8 }).then( resp => {
                    
                const { success, message, usuarioActualAsignacion, usuarioAsignacion } = resp;

                if( success ){

                    setTimeout(() => {

                        if( usuarioActualAsignacion ){

                            handleNext();
                            setLoadingNext( false );
                        
                        }
                        else{                        
                            setAjaxFinish( true );
                            setMensajeAsignacion( 'La siguiente actividad se asignó a ' + ( usuarioAsignacion ?? '' ) );  
                        }
                    
                    }, 700);
                }
                else {

                    setTimeout(() => {
                        
                        dispatch( openSnackbar({ message: message, variant: 'error' }));   
                        setLoadingNext( false );

                    }, 700);

                }

            }); 

        }
        
    }

    const handlegenerarAcuse = async () => {

        setLoading( true );

        await GenerarAcuse({ id: recepcion.id ?? '' }).then( resp => {
                
            const { success, message, acuse, acuseFirmado } = resp;

            if( success ){

                setTimeout(() => {
            
                    setDocumento( acuseFirmado ? ( acuseFirmado ?? '' ) : ( acuse ?? '' ) );
                    setOpenAcuse( true );
                    setLoading( false );
                    
                    dispatch( setReducerRecepcion({ ...recepcion, acuse, acuseFirmado, }) );

                }, 700);

            }
            else {

                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: message, variant: 'error' }));   
                    setLoadingBack( false );

                }, 700);

            }

        }); 

    }

    useEffect(() => {

        if( recepcion.acuseFirmado ){
            setDocumento( recepcion.acuseFirmado );
        }
        else if( recepcion.acuse ){
            setDocumento( recepcion.acuse );
        }

        if( recepcion.partes?.length !== 0 ){
            setPartes( recepcion.partes ?? [] );
        }  

        if( recepcion.anexos?.length !== 0 ){
            setAnexos( recepcion.anexos ?? [] );
        }

    }, [ recepcion ])    

    useEffect(() => {

        if( error ){
            setLoadingNext( false );
            dispatch( openSnackbar({ message: error, variant: 'warning' }));   
        }

    }, [ error, dispatch ])    
  
    return (
        <Grid container spacing={3} mt={2}>

            <Grid size={{ md: 12, xs: 12 }}>

                <Paper sx={{ borderRadius: 3 }}>      

                    <Box sx={{ ...TableTheadStyle, ...TablePaddingStyle, borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>      

                        <Grid container spacing={3}>

                            <Grid size={6}>
                                <Typography variant="h4">
                                    EXH. { recepcion.numeroExhorto }
                                </Typography>
                            </Grid>

                            <Grid size={6} textAlign={'end'}>

                                {
                                    recepcion.provieneBuzonElectronico
                                    &&
                                        <Chip 
                                            variant='filled' 
                                            sx={{ bgcolor: 'white', borderRadius: 2, p: 2 }} 
                                            label={ <Typography variant='h6'> RT-{ numeroSeguimiento } </Typography> } 
                                        />
                                }
                                
                            </Grid>

                        </Grid>                 

                    </Box>  

                    <Box sx={{ px: 3 }}>

                        <Grid container spacing={3}>

                            <Grid size={{ md: 6, xs: 12 }}>

                                <List disablePadding>

                                    <ListItem sx={{ py: 1, px: 0 }}>

                                        <ListItemText
                                            sx={{ mr: 2 }}
                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de seguimiento: </Typography> }
                                            secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> RT-{ numeroSeguimiento } </Typography> }
                                        />

                                    </ListItem>

                                    <ListItem sx={{ py: 1, px: 0 }}>

                                        <ListItemText
                                            sx={{ mr: 2 }}
                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Fecha de recepción: </Typography> }
                                            secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { recepcion.fechaRecepcion } </Typography> }
                                        />

                                    </ListItem>                                   
                                    
                                    <ListItem sx={{ py: 1, px: 0 }}>

                                        <ListItemText
                                            sx={{ mr: 2 }}
                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Matería: </Typography> }
                                            secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { recepcion.materia } </Typography> }
                                        />

                                    </ListItem>        

                                    <ListItem sx={{ py: 1, px: 0 }}>

                                        <ListItemText
                                            sx={{ mr: 2 }}
                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Autoridad del exhorto: </Typography> }
                                            secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { recepcion.autoridadExhorto } </Typography> }
                                        />

                                    </ListItem>                              

                                </List>

                            </Grid>
                            
                            <Grid size={{ md: 6, xs: 12 }}>

                                <List disablePadding>

                                    <ListItem sx={{ py: 1, px: 0 }}>

                                        <ListItemText
                                            sx={{ mr: 2 }}
                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Presentante: </Typography> }
                                            secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { recepcion.presentante } </Typography> }
                                        />

                                    </ListItem>

                                    <ListItem sx={{ py: 1, px: 0 }}>

                                        <ListItemText
                                            sx={{ mr: 2 }}
                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de expediente de origen: </Typography> }
                                            secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { recepcion.numeroExpedienteOrigen } </Typography> }
                                        />

                                    </ListItem>

                                    <ListItem sx={{ py: 1, px: 0 }}>

                                        <ListItemText
                                            sx={{ mr: 2 }}
                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de juicio: </Typography> }
                                            secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { recepcion.tipoJuicio } </Typography> }
                                        />

                                    </ListItem>    

                                    {
                                        recepcion.fechaReloj
                                        &&
                                            <ListItem sx={{ py: 1, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Fecha de reloj: </Typography> }
                                                    secondary={ 
                                                        <Typography variant='subtitle2' fontWeight={'bold'}> 
                                                            { 
                                                                moment( new Date( recepcion.fechaReloj ) ).format("DD-MM-YYYY hh:mm a")
                                                            } 
                                                        </Typography> 
                                                    }
                                                />

                                            </ListItem>
                                    }

                                </List>

                            </Grid>

                        </Grid>                    
                    
                    </Box>

                </Paper>
            
            </Grid>

            <Grid size={{ md: 12, xs: 12 }}>                

                <TableContainer sx={{ borderRadius: 3 }}>

                    <Table sx={{ minWidth: 500 }}>

                        <TableBody>

                            <TableRow sx={{ ...TableTheadStyle }}>
                                <TableCell colSpan={2}>
                                    <Typography style={{ ...TableTheadStyle, fontWeight: 'bold' }}>
                                        Parte(s)
                                    </Typography>
                                </TableCell>
                            </TableRow>

                            {
                                partes 
                                ?
                                    partes.map( ( { persona, tipoParte }, index ) => (

                                        <TableRow key={ index }>
                                            <TableCell> <Typography style={{ fontSize: 14 }} > { persona } </Typography> </TableCell>
                                            <TableCell> <Typography style={{ fontSize: 14, fontWeight: 'bold' }} > { tipoParte } </Typography> </TableCell>
                                        </TableRow>

                                    ))
                                :
                                    <TableRow>

                                        <TableCell sx={{ textAlign: 'center' }} colSpan={5}> 

                                            <Typography variant="caption" color='secondary'>No se agregaron partes </Typography>

                                        </TableCell>

                                    </TableRow>
                            }              

                        </TableBody>

                    </Table>

                </TableContainer>                    

            </Grid>          

            <Grid size={{ md: 12, xs: 12 }}>

                <TableContainer sx={{ borderRadius: 3 }}>

                    <Table sx={{ minWidth: 500 }}>                          

                        <TableBody>

                            <TableRow sx={{ ...TableTheadStyle }}>
                                <TableCell colSpan={8}>
                                    <Typography style={{ ...TableTheadStyle, fontWeight: 'bold',  }}>
                                        Anexo(s)
                                    </Typography>
                                </TableCell>
                            </TableRow>

                            {
                                anexos.length > 0
                                ?
                                    anexos
                                    .map( ( { tipoAnexo, tipoFormato, cantidad, numeroFojas, observaciones }, index ) => (

                                        <TableRow key={ index }>
                                            <TableCell>{ tipoAnexo }</TableCell>    
                                            <TableCell>{ tipoFormato }</TableCell>    
                                            <TableCell>{ cantidad }</TableCell>    
                                            <TableCell>{ numeroFojas }</TableCell>     
                                            <TableCell>{ observaciones }</TableCell>        
                                        </TableRow>

                                    ))
                                :                                                                      
                                    <TableRow>

                                        <TableCell sx={{ textAlign: 'center' }} colSpan={5}>
                                            
                                            <Typography variant="caption" color='secondary'>No se agregaron anexo(s) </Typography>

                                        </TableCell>

                                    </TableRow>
                            }

                        </TableBody>

                    </Table>

                </TableContainer>

            </Grid>           

            <Grid size={{ md: 12, xs: 12}} sx={{ mt: 3 }}>  
        
                <Grid container spacing={3}>

                    <Grid size={{ md: 4, xs: 4 }} style={{ textAlign: 'left' }}>
                        <IconButton
                            color='primary'
                            onClick={ handleRegresar }
                            loading={ loadingBack }
                            disabled={ loading || ( recepcion?.provieneBuzonElectronico && loadingNext ) }
                        >
                            <GrPrevious />
                        </IconButton>
                    </Grid>

                    <Grid size={{ md: 4, xs: 4 }} style={{ textAlign: 'center' }}>  

                        <Grid container spacing={1}>

                            <Grid size={{ md: 12, xs: 12 }}>
                        
                                {
                                    !recepcion.acuseFirmado
                                    ?
                                        <Button 
                                            variant="contained" 
                                            startIcon={ <FileCopyIcon /> } 
                                            onClick={ handlegenerarAcuse } 
                                            loading={ loading }
                                        >
                                            Generar acuse de recibo
                                        </Button>
                                    :
                                        <Button 
                                            variant="contained" 
                                            startIcon={ <PrintIcon /> } 
                                            onClick={ () => { setOpenAcuse( true ); } } 
                                            disabled={ recepcion?.provieneBuzonElectronico && loadingNext }
                                        >
                                            Visualizar acuse de recibo
                                        </Button>                    
                                }           

                            </Grid>

                            {
                                ( !recepcion.provieneBuzonElectronico && documento !== '' )
                                &&
                                    <Grid size={{ md: 12, xs: 12 }}>                       
                                
                                        <Button                                      
                                            color='secondary'
                                            startIcon={ <WhatsAppIcon fontSize='small' color='success' /> }
                                            onClick={ () => setOpenEnviarWhatsApp( true ) } 
                                        >
                                            Enviar por WhatsApp
                                        </Button>   

                                    </Grid>
                            }                           

                        </Grid>                        

                    </Grid>

                    <Grid size={{ md: 4, xs: 4 }} style={{ textAlign: 'right' }}>  
                        <IconButton 
                            color='primary'
                            onClick={ handleSiguiente }
                            loading={ loadingNext }
                            disabled={ documento === '' || loading }
                        > 
                            { recepcion?.provieneBuzonElectronico ? <CheckCircleIcon fontSize='large' /> : <GrNext /> }
                        </IconButton>
                    </Grid>                                          

                </Grid>

            </Grid>   

            <Dialog 
                maxWidth="md"
                fullWidth={ true } 
                open={ openAcuse } 
                fullScreen={ fullScreen } 
                onClose={ () => {} } 
            >       

                <DialogTitle sx={{ backgroundColor: '#3c3c3c', p: 0, textAlign: 'end' }}>
                
                    <IconButton size='small' sx={{ color: 'white' }} onClick={ () => setFullScreen( (prev) => !prev ) }>
                        { fullScreen ? <FullscreenExitIcon /> : <FullscreenIcon /> } 
                    </IconButton>

                    <IconButton size='small' sx={{ color: 'white' }} onClick={ () => setOpenAcuse( false ) }>
                        <CloseIcon />
                    </IconButton>
                
                </DialogTitle>        
              
               <DialogContent sx={{ p: 0 }}>
                  
                   <Grid container spacing={3} height={'100%'} >                                                
                   
                       <Grid size={{ md: 12, xs: 12}} sx={{ display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
 
                            {
                                documento
                                ?
                                   <iframe title='acuse' src={ documento } height={ fullScreen ? "100%" : '500px' } width="100%" style={{ border: 'none' }}></iframe>
                                :
                                    <Typography variant='subtitle2' sx={{ fontSize: 18, fontWeight: 'bold', mt: 10, mb: 10 }}>
                                        No se encontró el acuse de recibo
                                    </Typography>                          
                            }

                       </Grid>
                      
                   </Grid>
                  
               </DialogContent> 

            </Dialog>  

            <DialogEnviarWhatsApp       
                openDialog={ openEnviarWhatsApp }
                handleCloseDialog={ () => setOpenEnviarWhatsApp( false ) }
                telefonoCelular={ recepcion.telefonoCelular ?? '' }
            />          

        </Grid>
    )
}
